import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "bg-gray-50 p-2 rounded border border-gray-200 text-xs leading-tight mb-2"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "py-1"
};
const _hoisted_6 = {
  class: "bg-white border border-gray-200 rounded p-2 mb-2"
};
const _hoisted_7 = {
  class: "bg-white border border-gray-200 rounded p-2"
};
const _hoisted_8 = {
  key: 0,
  class: "mt-1"
};
const _hoisted_9 = {
  class: "text-error text-xs mt-1"
};
import { onMounted, reactive } from 'vue';
import { useExpenseSettingStore } from './expenseSettingStore.js';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextField from '@/components/LlTextField.vue';
export default {
  __name: 'ServiceSetup',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    messageText: {
      type: String,
      required: true
    },
    expenseWizardState: {
      type: Object,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    filteredService: {
      type: Array,
      required: true
    },
    modalValue: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const serviceSetupState = reactive({
      loading: false,
      create: false,
      name: '',
      filteredServices: [],
      services: [],
      selectedService: {}
    });
    const expenseSettingStore = useExpenseSettingStore();
    expenseSettingStore.alerts = props.alerts;
    onMounted(async () => {
      serviceSetupState.loading = true;
      serviceSetupState.name = props.modalValue.name;
      if (expenseSettingStore.data.step === 2) {
        serviceSetupState.selectedService = props.expenseWizardState.data.incomeService.service;
        serviceSetupState.create = props.expenseWizardState.data.incomeService.create;
        // Immediately update store like AccountSetup does
        expenseSettingStore.data.incomeService.service = serviceSetupState.selectedService;
        expenseSettingStore.data.incomeService.create = serviceSetupState.create;
        expenseSettingStore.data.incomeService.name = serviceSetupState.name || '';
      } else if (expenseSettingStore.data.step === 5) {
        serviceSetupState.selectedService = props.expenseWizardState.data.hardService.service;
        serviceSetupState.create = props.expenseWizardState.data.hardService.create;
        // Immediately update store like AccountSetup does
        expenseSettingStore.data.hardService.service = serviceSetupState.selectedService;
        expenseSettingStore.data.hardService.create = serviceSetupState.create;
        expenseSettingStore.data.hardService.name = serviceSetupState.name || '';
      } else if (expenseSettingStore.data.step === 9) {
        serviceSetupState.selectedService = props.expenseWizardState.data.softService.service;
        serviceSetupState.create = props.expenseWizardState.data.softService.create;
        // Immediately update store like AccountSetup does
        expenseSettingStore.data.softService.service = serviceSetupState.selectedService;
        expenseSettingStore.data.softService.create = serviceSetupState.create;
        expenseSettingStore.data.softService.name = serviceSetupState.name || '';
      }
      serviceSetupState.loading = false;
    });
    const changeServiceType = value => {
      serviceSetupState.create = false;
      if (expenseSettingStore.data.step === 2) {
        props.expenseWizardState.data.incomeService.service = value;
        props.expenseWizardState.data.incomeService.create = false;
        expenseSettingStore.data.incomeService.service = value;
        expenseSettingStore.data.incomeService.create = false;
      } else if (expenseSettingStore.data.step === 5) {
        props.expenseWizardState.data.hardService.service = value;
        props.expenseWizardState.data.hardService.create = false;
        expenseSettingStore.data.hardService.service = value;
        expenseSettingStore.data.hardService.create = false;
      } else if (expenseSettingStore.data.step === 9) {
        props.expenseWizardState.data.softService.service = value;
        props.expenseWizardState.data.softService.create = false;
        expenseSettingStore.data.softService.service = value;
        expenseSettingStore.data.softService.create = false;
      }
    };
    const createService = value => {
      if (expenseSettingStore.data.step === 2) {
        serviceSetupState.create = value;
        serviceSetupState.selectedService = null;
        props.expenseWizardState.data.incomeService.service = null;
        props.expenseWizardState.data.incomeService.create = value;
        expenseSettingStore.data.incomeService.create = value;
        expenseSettingStore.data.incomeService.service = null;
        // Set default recommendation when creating, clear when not
        if (value) {
          serviceSetupState.name = 'Legal Services';
          props.expenseWizardState.data.incomeService.name = 'Legal Services';
          expenseSettingStore.data.incomeService.name = 'Legal Services';
        } else {
          serviceSetupState.name = '';
          props.expenseWizardState.data.incomeService.name = '';
          expenseSettingStore.data.incomeService.name = '';
        }
      } else if (expenseSettingStore.data.step === 5) {
        serviceSetupState.create = value;
        serviceSetupState.selectedService = null;
        props.expenseWizardState.data.hardService.service = null;
        props.expenseWizardState.data.hardService.create = value;
        expenseSettingStore.data.hardService.create = value;
        expenseSettingStore.data.hardService.service = null;
        // Set default recommendation when creating, clear when not
        if (value) {
          serviceSetupState.name = 'Prepaid Expenses';
          props.expenseWizardState.data.hardService.name = 'Prepaid Expenses';
          expenseSettingStore.data.hardService.name = 'Prepaid Expenses';
        } else {
          serviceSetupState.name = '';
          props.expenseWizardState.data.hardService.name = '';
          expenseSettingStore.data.hardService.name = '';
        }
      } else if (expenseSettingStore.data.step === 9) {
        serviceSetupState.create = value;
        serviceSetupState.selectedService = null;
        props.expenseWizardState.data.softService.service = null;
        props.expenseWizardState.data.softService.create = value;
        expenseSettingStore.data.softService.create = value;
        expenseSettingStore.data.softService.service = null;
        // Set default recommendation when creating, clear when not
        if (value) {
          serviceSetupState.name = 'Billable Expenses';
          props.expenseWizardState.data.softService.name = 'Billable Expenses';
          expenseSettingStore.data.softService.name = 'Billable Expenses';
        } else {
          serviceSetupState.name = '';
          props.expenseWizardState.data.softService.name = '';
          expenseSettingStore.data.softService.name = '';
        }
      }
    };
    const handleServiceChange = () => {
      if (expenseSettingStore.data.step === 2) {
        props.expenseWizardState.data.incomeService.name = serviceSetupState.name;
        expenseSettingStore.data.incomeService.name = serviceSetupState.name;
      } else if (expenseSettingStore.data.step === 5) {
        props.expenseWizardState.data.hardService.name = serviceSetupState.name;
        expenseSettingStore.data.hardService.name = serviceSetupState.name;
      } else if (expenseSettingStore.data.step === 9) {
        props.expenseWizardState.data.softService.name = serviceSetupState.name;
        expenseSettingStore.data.softService.name = serviceSetupState.name;
      }
    };
    const exists = () => {
      return props.services?.filter(service => service.name === serviceSetupState.name).length > 0;
    };
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        class: "w-full h-full pa-2"
      }, {
        default: _withCtx(() => [serviceSetupState.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
          color: "success",
          indeterminate: ""
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          innerHTML: __props.messageText
        }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "flex items-center text-sm mb-1"
        }, [_createElementVNode("img", {
          src: "/img/qb16x16.png",
          style: {
            "margin-right": "6px",
            "height": "14px",
            "width": "14px"
          }
        }), _createElementVNode("strong", null, "Pick existing product/service")], -1)), _createVNode(LlSelect, {
          items: __props.filteredService,
          modelValue: serviceSetupState.selectedService,
          "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => serviceSetupState.selectedService = $event), changeServiceType],
          "item-title": 'name',
          "item-value": 'id',
          "return-object": true,
          clearable: true,
          "is-autocomplete": true,
          placeholder: "Select Service",
          "hide-details": true,
          class: "w-full"
        }, null, 8, ["items", "modelValue"])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "text-center py-1 mb-1"
        }, [_createElementVNode("span", null, [_createElementVNode("em", null, "- or -")])], -1)), _createElementVNode("div", _hoisted_7, [_createVNode(LlCheckbox, {
          modelValue: serviceSetupState.create,
          "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => serviceSetupState.create = $event), createService],
          label: "Create a new product/service in QuickBooks"
        }, null, 8, ["modelValue"]), serviceSetupState.create ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(LlTextField, {
          modelValue: serviceSetupState.name,
          "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => serviceSetupState.name = $event), handleServiceChange],
          disabled: !serviceSetupState.create,
          placeholder: "Service name",
          "hide-details": true,
          class: "w-full"
        }, null, 8, ["modelValue", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
          class: "fa fa-warning"
        }, null, -1), _createTextVNode(" Name exists ", -1)]))], 512), [[_vShow, exists()]]), _cache[5] || (_cache[5] = _createElementVNode("p", {
          class: "text-gray-500 text-xs mt-1"
        }, " This will create a service/product in QuickBooks that can be used for billing. ", -1))])) : _createCommentVNode("", true)])])]))]),
        _: 1
      });
    };
  }
};